// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rbc-calendar,
.rbc-off-range-bg {
  background: var(--calendar-bg);
}

.rbc-row-bg {
  z-index: 4;
}


.rbc-addons-dnd-row-body {
  position: relative;
  pointer-events: auto;
}

.rbc-date-cell {
  height: 25px;
  color: var(--color-text);
}

.dark .rbc-date-cell {
  color: #ffffff;
}

.rbc-event {
  pointer-events: all;
}

.rbc-event,
.rbc-event.rbc-selected {
  background-color: inherit;
  color: var(--calendar-event-color);
  height: 40px !important;
  z-index: 9 !important;
  position: relative;
  padding: 0px 2px;
}

.rbc-event-content {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 0;
}

.rbc-day-slot.rbc-time-column div .rbc-events-container {
  margin: 0px 3px 0px 3px;
}

.rbc-row-segment {
  height: 40px;
}

.rbc-event:focus,
.rbc-day-slot .rbc-background-event:focus {
  outline: none;
}

.rbc-event-label {
  display: none;
}

.rbc-day-slot .rbc-event {
  border: unset;
}

.rbc-event>.rbc-event-content {
  width: 100%;
}

.rbc-time-content {
  border-top: 0px !important;
}

.rbc-month-row {
  border-top: 0px !important;
}

.rbc-month-view {
  border: 0px !important;
}

.rbc-header+.rbc-header {
  border-inline-start: 0px !important;
}

.cal-toolbar-today {
  margin-block-start: 7px;
  margin-inline-end: 24px;
  margin-inline-start: 7px;
}

.rbc-row.rbc-time-header-cell>.rbc-header {
  border-top: 0px !important
}

.rbc-time-content>*+*>* {
  border-inline-start: 0px !important;
}

.rbc-toolbar .rbc-toolbar-label,
.rbc-toolbar .rbc-btn-group button,
.rbc-header {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
}

.rbc-header {
  text-transform: uppercase;
  color: var(--calendar-header);
  font-size: 11px;
  font-weight: 500;
  line-height: 20px;
  border-top: 1px solid var(--color-border) !important;
}

.rbc-today {
  background-color: initial;
}

.rbc-now.rbc-current .rbc-button-link {
  background-color: var(--calendar-today-label-bg);
  color: var(--color-accent-contrast);
  border-radius: 10px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.rbc-day-slot .rbc-time-slot {
  border-top: unset;
}

.rbc-timeslot-group,
.rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td,
.rbc-header,
.rbc-agenda-table>thead>tr>.rbc-header {
  border-bottom: 1px solid var(--color-border) !important;
}

.rbc-row.rbc-month-header> :nth-child(7),
.rbc-agenda-view table.rbc-agenda-table thead>tr>th,
.rbc-time-header.rbc-overflowing {
  border-inline-end: 1px solid var(--color-border) !important;
}

/* Align week/day header columns with the body grid columns.
   react-big-calendar measures the default OS scrollbar (~15px) and reserves
   it as an inline margin on the overflowing header, but our time-content uses
   a custom 8px-wide scrollbar (see .rbc-time-content webkit-scrollbar below).
   The 7px over-reservation made the header columns narrower than the body
   columns, so the vertical day-dividers drifted ~1px per column and looked
   crooked. Override the inline margin to match the real scrollbar:
   7px margin + 1px border-inline-end = 8px = actual scrollbar width. */
.rbc-time-header.rbc-overflowing {
  margin-inline-end: 7px !important;
}

.rbc-day-slot.rbc-time-column,
.rbc-row.rbc-month-header> :nth-child(1),
.rbc-month-row>.rbc-row-bg> :nth-child(1),
.rbc-time-header-content,
.rbc-day-bg+.rbc-day-bg,
.rbc-agenda-view table.rbc-agenda-table thead>tr>th,
.rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td {
  border-inline-start: 1px solid var(--color-border) !important;
}

.rbc-agenda-time-cell,
.rbc-time-view,
.rbc-agenda-view table.rbc-agenda-table {
  border: 1px solid var(--color-border) !important;
}

.rbc-header.rbc-today>button>span {
  font-weight: bold;
}


.rbc-timeslot-group>* {
  height: 37px !important;
  box-sizing: border-box !important;
}

.rbc-time-gutter.rbc-time-column {
  border-top: 1px solid var(--color-border) !important;
}

.rbc-label.rbc-time-header-gutter,
.rbc-time-gutter.rbc-time-column {
  width: 85px !important;
}

.rbc-time-gutter.rbc-time-column>.rbc-timeslot-group>:nth-child(2) {
  visibility: hidden !important;
}

.rbc-day-slot.rbc-time-column>.rbc-timeslot-group>div {
  opacity: 0 !important;
  transition: opacity 0.2s;
}

.rbc-day-slot.rbc-time-column>.rbc-timeslot-group>div:hover {
  opacity: 1 !important;
}

.rbc-time-header.rbc-overflowingt {
  margin-inline-end: 16px !important;
}

.rbc-date-cell>div>:nth-child(2) {
  opacity: 0;
}

.rbc-date-cell:hover>div> :nth-child(2) {
  opacity: 1 !important;
}

.rbc-row-segment:has(.rbc-button-link.rbc-show-more) {
  height: 22px !important;
}

/* Show more link styling for better contrast in dark mode */
.rbc-button-link.rbc-show-more {
  color: var(--color-text-muted) !important;
  text-decoration: none !important;
  font-size: 14px !important;
  font-weight: 500 !important;
}

.rbc-button-link.rbc-show-more:hover {
  color: var(--color-accent) !important;
  text-decoration: underline !important;
}



.rbc-row-content, .rbc-addons-dnd-row-body, .rbc-row, .rbc-row-segment {
  pointer-events: none!important;
}


/* .rbc-row-bg>div:hover{
  .rbc-date-cell>div>:nth-child(2) {
    opacity: 1 !important;
  }
} */


/* .rbc-row-content,
.rbc-row-content .rbc-addons-dnd-row-body,
.rbc-row-content .rbc-row,
.rbc-row-content .rbc-row-segment,
.rbc-row-content .rbc-event,
.rbc-row-content .rbc-row-contentrbc-event-content {
  pointer-events: none;
} */

/* Fix for DnD issues */
.rbc-addons-dnd {
  .rbc-addons-dnd-row-body {
    position: relative;
    pointer-events: auto;
  }

  /* Consistent drag preview styling across all views */
  .rbc-addons-dnd-drag-preview {
    position: absolute !important;
    z-index: 1000;
    pointer-events: none;
    width: 180px !important;
    height: 40px !important;
    transition: none !important;
    background-color: inherit;
    opacity: 0.8;
    box-shadow: 0 2px 6px var(--modal-shadow);

    /* Force consistent styling */
    .rbc-event-content {
      width: 100% !important;
      height: 100% !important;
      padding: 2px 4px !important;
    }
  }

  .rbc-event {
    transition: opacity 0.3s;
    cursor: move;

    &.rbc-addons-dnd-dragged-event {
      opacity: 0.5;
    }
  }

  /* View specific adjustments */
  .rbc-time-view & {
    .rbc-addons-dnd-drag-preview {
      position: absolute !important;
      left: auto !important;
      margin: 0 !important;
    }
  }

  /* Prevent scroll jumps in time views */
  .rbc-time-view {
    overflow: hidden !important;

    .rbc-time-content {
      overflow-y: scroll !important;
      overflow-x: hidden !important;

      &::-webkit-scrollbar {
        width: 8px;
      }
    }
  }
}

/* --- Consistent month-row height + scroll ---------------------------------
   react-big-calendar normally squeezes the whole month into a fixed height,
   so a 6-week month (e.g. May) gets shorter day-cells than a 5-week month
   (e.g. June). The same day then shows a different number of events between
   views ("+2 more" in one month, all 3 in another). Pin every week-row to the
   same height so a given day always shows the same events in any month, and
   let the grid scroll vertically when the rows overflow the viewport. */
.rbc-month-view {
  overflow-y: auto !important;
}

.rbc-month-view .rbc-month-row {
  /* Don't grow/shrink rows to fit the viewport — keep them a constant height.
     Room for the date number (~25px) + 3 events (40px each) + "show more". */
  flex: 0 0 180px !important;
  height: 180px !important;
  min-height: 180px !important;
  max-height: 180px !important;
}

/* Keep the weekday header visible while the weeks scroll. */
.rbc-month-view .rbc-month-header {
  position: sticky;
  top: 0;
  z-index: 6;
  background: var(--calendar-bg);
}

/* Prevent pointer event issues in time views */
.rbc-time-view {
  .rbc-events-container {
    pointer-events: none;
  }

  .rbc-event {
    pointer-events: all !important;
  }

  .rbc-time-slot {
    pointer-events: all !important;
  }
}

.rbc-events-container {
  pointer-events: none;

  .rbc-event {
    pointer-events: auto;
  }
}

/* --- Phone-width overrides -----------------------------------------------
   On narrow screens the fixed 85px time gutter and the 180px pinned month
   rows push the week/month grids wider/taller than the viewport. Shrink the
   gutter and month-row height so the grids fit without horizontal overflow. */
@media (max-width: 785px) {
  .rbc-label.rbc-time-header-gutter,
  .rbc-time-gutter.rbc-time-column {
    width: 48px !important;
  }

  .rbc-month-view .rbc-month-row {
    flex: 0 0 120px !important;
    height: 120px !important;
    min-height: 120px !important;
    max-height: 120px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/views/calendar/calendar-custom.css"],"names":[],"mappings":"AAAA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;EAGE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oDAAoD;AACtD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;EAChD,mCAAmC;EACnC,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,uDAAuD;AACzD;;AAEA;;;EAGE,2DAA2D;AAC7D;;AAEA;;;;;;;uEAOuE;AACvE;EACE,iCAAiC;AACnC;;AAEA;;;;;;;EAOE,6DAA6D;AAC/D;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,4DAA4D;AAC5D;EACE,yCAAyC;EACzC,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;;;;AAIA;EACE,8BAA8B;AAChC;;;AAGA;;;;GAIG;;;AAGH;;;;;;;GAOG;;AAEH,uBAAuB;AACvB;EACE;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA,qDAAqD;EACrD;IACE,6BAA6B;IAC7B,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,uBAAuB;IACvB,2BAA2B;IAC3B,yBAAyB;IACzB,YAAY;IACZ,yCAAyC;;IAEzC,6BAA6B;IAC7B;MACE,sBAAsB;MACtB,uBAAuB;MACvB,2BAA2B;IAC7B;EACF;;EAEA;IACE,wBAAwB;IACxB,YAAY;;IAEZ;MACE,YAAY;IACd;EACF;;EAEA,8BAA8B;EAC9B;IACE;MACE,6BAA6B;MAC7B,qBAAqB;MACrB,oBAAoB;IACtB;EACF;;EAEA,uCAAuC;EACvC;IACE,2BAA2B;;IAE3B;MACE,6BAA6B;MAC7B,6BAA6B;;MAE7B;QACE,UAAU;MACZ;IACF;EACF;AACF;;AAEA;;;;;;wEAMwE;AACxE;EACE,2BAA2B;AAC7B;;AAEA;EACE;6EAC2E;EAC3E,0BAA0B;EAC1B,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,8BAA8B;AAChC;;AAEA,+CAA+C;AAC/C;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,oBAAoB;;EAEpB;IACE,oBAAoB;EACtB;AACF;;AAEA;;;8EAG8E;AAC9E;EACE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;IAC5B,4BAA4B;EAC9B;AACF","sourcesContent":[".rbc-calendar,\n.rbc-off-range-bg {\n  background: var(--calendar-bg);\n}\n\n.rbc-row-bg {\n  z-index: 4;\n}\n\n\n.rbc-addons-dnd-row-body {\n  position: relative;\n  pointer-events: auto;\n}\n\n.rbc-date-cell {\n  height: 25px;\n  color: var(--color-text);\n}\n\n.dark .rbc-date-cell {\n  color: #ffffff;\n}\n\n.rbc-event {\n  pointer-events: all;\n}\n\n.rbc-event,\n.rbc-event.rbc-selected {\n  background-color: inherit;\n  color: var(--calendar-event-color);\n  height: 40px !important;\n  z-index: 9 !important;\n  position: relative;\n  padding: 0px 2px;\n}\n\n.rbc-event-content {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  z-index: 0;\n}\n\n.rbc-day-slot.rbc-time-column div .rbc-events-container {\n  margin: 0px 3px 0px 3px;\n}\n\n.rbc-row-segment {\n  height: 40px;\n}\n\n.rbc-event:focus,\n.rbc-day-slot .rbc-background-event:focus {\n  outline: none;\n}\n\n.rbc-event-label {\n  display: none;\n}\n\n.rbc-day-slot .rbc-event {\n  border: unset;\n}\n\n.rbc-event>.rbc-event-content {\n  width: 100%;\n}\n\n.rbc-time-content {\n  border-top: 0px !important;\n}\n\n.rbc-month-row {\n  border-top: 0px !important;\n}\n\n.rbc-month-view {\n  border: 0px !important;\n}\n\n.rbc-header+.rbc-header {\n  border-inline-start: 0px !important;\n}\n\n.cal-toolbar-today {\n  margin-block-start: 7px;\n  margin-inline-end: 24px;\n  margin-inline-start: 7px;\n}\n\n.rbc-row.rbc-time-header-cell>.rbc-header {\n  border-top: 0px !important\n}\n\n.rbc-time-content>*+*>* {\n  border-inline-start: 0px !important;\n}\n\n.rbc-toolbar .rbc-toolbar-label,\n.rbc-toolbar .rbc-btn-group button,\n.rbc-header {\n  font-family: \"Google Sans\", Roboto, Arial, sans-serif;\n}\n\n.rbc-header {\n  text-transform: uppercase;\n  color: var(--calendar-header);\n  font-size: 11px;\n  font-weight: 500;\n  line-height: 20px;\n  border-top: 1px solid var(--color-border) !important;\n}\n\n.rbc-today {\n  background-color: initial;\n}\n\n.rbc-now.rbc-current .rbc-button-link {\n  background-color: var(--calendar-today-label-bg);\n  color: var(--color-accent-contrast);\n  border-radius: 10px;\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n\n.rbc-day-slot .rbc-time-slot {\n  border-top: unset;\n}\n\n.rbc-timeslot-group,\n.rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td,\n.rbc-header,\n.rbc-agenda-table>thead>tr>.rbc-header {\n  border-bottom: 1px solid var(--color-border) !important;\n}\n\n.rbc-row.rbc-month-header> :nth-child(7),\n.rbc-agenda-view table.rbc-agenda-table thead>tr>th,\n.rbc-time-header.rbc-overflowing {\n  border-inline-end: 1px solid var(--color-border) !important;\n}\n\n/* Align week/day header columns with the body grid columns.\n   react-big-calendar measures the default OS scrollbar (~15px) and reserves\n   it as an inline margin on the overflowing header, but our time-content uses\n   a custom 8px-wide scrollbar (see .rbc-time-content webkit-scrollbar below).\n   The 7px over-reservation made the header columns narrower than the body\n   columns, so the vertical day-dividers drifted ~1px per column and looked\n   crooked. Override the inline margin to match the real scrollbar:\n   7px margin + 1px border-inline-end = 8px = actual scrollbar width. */\n.rbc-time-header.rbc-overflowing {\n  margin-inline-end: 7px !important;\n}\n\n.rbc-day-slot.rbc-time-column,\n.rbc-row.rbc-month-header> :nth-child(1),\n.rbc-month-row>.rbc-row-bg> :nth-child(1),\n.rbc-time-header-content,\n.rbc-day-bg+.rbc-day-bg,\n.rbc-agenda-view table.rbc-agenda-table thead>tr>th,\n.rbc-agenda-view table.rbc-agenda-table tbody>tr>td+td {\n  border-inline-start: 1px solid var(--color-border) !important;\n}\n\n.rbc-agenda-time-cell,\n.rbc-time-view,\n.rbc-agenda-view table.rbc-agenda-table {\n  border: 1px solid var(--color-border) !important;\n}\n\n.rbc-header.rbc-today>button>span {\n  font-weight: bold;\n}\n\n\n.rbc-timeslot-group>* {\n  height: 37px !important;\n  box-sizing: border-box !important;\n}\n\n.rbc-time-gutter.rbc-time-column {\n  border-top: 1px solid var(--color-border) !important;\n}\n\n.rbc-label.rbc-time-header-gutter,\n.rbc-time-gutter.rbc-time-column {\n  width: 85px !important;\n}\n\n.rbc-time-gutter.rbc-time-column>.rbc-timeslot-group>:nth-child(2) {\n  visibility: hidden !important;\n}\n\n.rbc-day-slot.rbc-time-column>.rbc-timeslot-group>div {\n  opacity: 0 !important;\n  transition: opacity 0.2s;\n}\n\n.rbc-day-slot.rbc-time-column>.rbc-timeslot-group>div:hover {\n  opacity: 1 !important;\n}\n\n.rbc-time-header.rbc-overflowingt {\n  margin-inline-end: 16px !important;\n}\n\n.rbc-date-cell>div>:nth-child(2) {\n  opacity: 0;\n}\n\n.rbc-date-cell:hover>div> :nth-child(2) {\n  opacity: 1 !important;\n}\n\n.rbc-row-segment:has(.rbc-button-link.rbc-show-more) {\n  height: 22px !important;\n}\n\n/* Show more link styling for better contrast in dark mode */\n.rbc-button-link.rbc-show-more {\n  color: var(--color-text-muted) !important;\n  text-decoration: none !important;\n  font-size: 14px !important;\n  font-weight: 500 !important;\n}\n\n.rbc-button-link.rbc-show-more:hover {\n  color: var(--color-accent) !important;\n  text-decoration: underline !important;\n}\n\n\n\n.rbc-row-content, .rbc-addons-dnd-row-body, .rbc-row, .rbc-row-segment {\n  pointer-events: none!important;\n}\n\n\n/* .rbc-row-bg>div:hover{\n  .rbc-date-cell>div>:nth-child(2) {\n    opacity: 1 !important;\n  }\n} */\n\n\n/* .rbc-row-content,\n.rbc-row-content .rbc-addons-dnd-row-body,\n.rbc-row-content .rbc-row,\n.rbc-row-content .rbc-row-segment,\n.rbc-row-content .rbc-event,\n.rbc-row-content .rbc-row-contentrbc-event-content {\n  pointer-events: none;\n} */\n\n/* Fix for DnD issues */\n.rbc-addons-dnd {\n  .rbc-addons-dnd-row-body {\n    position: relative;\n    pointer-events: auto;\n  }\n\n  /* Consistent drag preview styling across all views */\n  .rbc-addons-dnd-drag-preview {\n    position: absolute !important;\n    z-index: 1000;\n    pointer-events: none;\n    width: 180px !important;\n    height: 40px !important;\n    transition: none !important;\n    background-color: inherit;\n    opacity: 0.8;\n    box-shadow: 0 2px 6px var(--modal-shadow);\n\n    /* Force consistent styling */\n    .rbc-event-content {\n      width: 100% !important;\n      height: 100% !important;\n      padding: 2px 4px !important;\n    }\n  }\n\n  .rbc-event {\n    transition: opacity 0.3s;\n    cursor: move;\n\n    &.rbc-addons-dnd-dragged-event {\n      opacity: 0.5;\n    }\n  }\n\n  /* View specific adjustments */\n  .rbc-time-view & {\n    .rbc-addons-dnd-drag-preview {\n      position: absolute !important;\n      left: auto !important;\n      margin: 0 !important;\n    }\n  }\n\n  /* Prevent scroll jumps in time views */\n  .rbc-time-view {\n    overflow: hidden !important;\n\n    .rbc-time-content {\n      overflow-y: scroll !important;\n      overflow-x: hidden !important;\n\n      &::-webkit-scrollbar {\n        width: 8px;\n      }\n    }\n  }\n}\n\n/* --- Consistent month-row height + scroll ---------------------------------\n   react-big-calendar normally squeezes the whole month into a fixed height,\n   so a 6-week month (e.g. May) gets shorter day-cells than a 5-week month\n   (e.g. June). The same day then shows a different number of events between\n   views (\"+2 more\" in one month, all 3 in another). Pin every week-row to the\n   same height so a given day always shows the same events in any month, and\n   let the grid scroll vertically when the rows overflow the viewport. */\n.rbc-month-view {\n  overflow-y: auto !important;\n}\n\n.rbc-month-view .rbc-month-row {\n  /* Don't grow/shrink rows to fit the viewport — keep them a constant height.\n     Room for the date number (~25px) + 3 events (40px each) + \"show more\". */\n  flex: 0 0 180px !important;\n  height: 180px !important;\n  min-height: 180px !important;\n  max-height: 180px !important;\n}\n\n/* Keep the weekday header visible while the weeks scroll. */\n.rbc-month-view .rbc-month-header {\n  position: sticky;\n  top: 0;\n  z-index: 6;\n  background: var(--calendar-bg);\n}\n\n/* Prevent pointer event issues in time views */\n.rbc-time-view {\n  .rbc-events-container {\n    pointer-events: none;\n  }\n\n  .rbc-event {\n    pointer-events: all !important;\n  }\n\n  .rbc-time-slot {\n    pointer-events: all !important;\n  }\n}\n\n.rbc-events-container {\n  pointer-events: none;\n\n  .rbc-event {\n    pointer-events: auto;\n  }\n}\n\n/* --- Phone-width overrides -----------------------------------------------\n   On narrow screens the fixed 85px time gutter and the 180px pinned month\n   rows push the week/month grids wider/taller than the viewport. Shrink the\n   gutter and month-row height so the grids fit without horizontal overflow. */\n@media (max-width: 785px) {\n  .rbc-label.rbc-time-header-gutter,\n  .rbc-time-gutter.rbc-time-column {\n    width: 48px !important;\n  }\n\n  .rbc-month-view .rbc-month-row {\n    flex: 0 0 120px !important;\n    height: 120px !important;\n    min-height: 120px !important;\n    max-height: 120px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
